import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { FilterOption } from "interface";
import { PurchaseStatistic } from "interface/purchaseStatistic";
import { useInfoStore } from "store/error";

export interface PurchaseStatisticFilter extends FilterOption{
    buyerId?: string,
    buyerName?: string,
    vesselLedgerAccountNumber?: string,
        fishermanLedgerAccount?: string,

    buyerLedgerAccount?: string
    vesselName?: string
    vesselId?: string
}
export async function getPurchaseStaticsApi(filter: PurchaseStatisticFilter) {
    const apiUri = "PurchaseStatistics";
    try {
        const statistics = await AxiosApi.get<ApiResponse<PurchaseStatistic[]>>(apiUri, {
            params: filter
        })
        return statistics.data.data
    } catch (error: any) {
          const { setError } = useInfoStore.getState();
          setError(error);
          throw  error
       }
}

export  async function getPurchaseStatisticsTotalApi(data: {fromDate: Date |null, toDate : Date |null, buyerLedgerAccount: number, fishermanLedgerAccount: number}) {

      const apiUrl =  "PurchaseStatistics/total"
     try {
          const totalResp = await AxiosApi.get(apiUrl, {
           params:{
           ...data
           }
           
       })
         return  totalResp.data.data
     } catch (error : any) {
           const { setError } = useInfoStore.getState();
          setError(error);
          throw  error
     }
}